export default "/fcbcac1db17390110677298f9d30eeed9c121039/e53673f1d35014610251dfa259b857bf.png";